/**
* 系统管理  公司管理
*/
<template>
  <div class="flex-all">
    <div>
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="使用门槛" prop="FullMoney">
          <el-input-number v-model="editForm.FullMoney" :min="1" :max="100000000000"></el-input-number>
          元
        </el-form-item>
        <el-form-item label="优惠金额" prop="ReductionMoney">
          <el-input-number v-model="editForm.ReductionMoney" :min="1" :max="100000000000"></el-input-number>元
        </el-form-item>
      </el-form>
      <div slot="footer" class="flex-all">
        <el-button type="primary" @click="editFn">修改</el-button>
      </div>
    </div>
  </div>

</template>

<script>
var operationFlag=true;
export default {
  data () {
    return {
      editForm: {
        FullMoney: 1,
        ReductionMoney: 1
      },
      rules: {
        FullMoney: [
          { required: true, message: '请修改使用门槛', trigger: 'change' }
        ],
        ReductionMoney: [
          { required: true, message: '请修改优惠金额', trigger: 'change' }
        ],
      }
    }
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created () {
    console.log(this.$api)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    editFn () {
      console.log(this.editForm)
      if (operationFlag) {
        operationFlag = false
        let data = {
          CompanyGUID: 'app.globalData.personInfo.CompanyGUID',
          FullMoney: this.editForm.FullMoney,
          ReductionMoney: this.editForm.ReductionMoney,
        };
        this.$loading()
        this.$api.UpdatePreferentialSetting(data).then(res=>{
          console.log(res,755)
          operationFlag = true;
          this.$loading().close()
          if (res.data.OK == "False") {
            this.$message({
              message:  res.data.Message,
              type: 'success'
            });
            return
          }
        })
      }
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/system/preferential.vue